import React, {Component} from 'react'
import {isMobileOnly} from 'react-device-detect'
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import styled from '@emotion/styled'
import i18next from 'i18next';

import {sourceConstants} from "../_constants";
import Footer from "../components/Footer"
import {Header} from "../components/Header"
import IdentifierPlayer from "../components/player/identifierPlayer/IdentifierPlayer";
import {Container, StyledMedia} from "../styles/CommonStyler"
import sv from '../styles/marketing'
import {ContentWrapper} from "../styles/PromoPagesStyler";

// STYLE ##########################################################

const Content = styled(`div`)`
    display: flex;
    flex-direction: column;
    flex-grow: 10;
    align-items: stretch;
    color: ${sv.colors.body};
`;

const Video = styled(`div`)`
  height: ${props => props.height};
  width: 100%;
`;

const Section = styled('div')`
    display: inline-flex;
    flex-wrap: wrap;
    margin: -40px 0 0 -40px;
`;

const Block = styled('div')`
    margin: 40px 0 0 40px;
    flex: 1 1 400px;
    
    p {
        margin-top: 5px;
    }
`;

const Title = styled('h1')`
    ${sv.title};
    width: 100%;
    text-align: start;
    color: ${sv.colors.headline}
`;

const Invite = styled('p')`
    ${sv.h3};
    width: 100%;
    text-align: start;
    font-weight: 300;
    margin-bottom: 8px;
    margin-top: 40px;
`;

const PitchButton = styled('div')`
  font-size: 15px;
  ${sv.buttonBase};
  background: ${sv.colors.cta};
  color: ${sv.colors.light};
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
  }
  margin: 32px 0;
`;

const Heading = styled('h2')`
    ${sv.h2};
    text-align: center;
    margin: 80px 40px 40px 40px;
    color: ${sv.colors.headline};
`;

const Additional = styled('div')`
    display: flex;
    flex-direction: column;
`;

const Example = styled(Block)`
    cursor: pointer;
    flex: 1 1 380px;
    
    @media(max-width: 932px) {
        flex: 1 1 260px;
    }
    
    @media(max-width: 760px) {
        flex: 1 1 220px;
    }
`;

const ExDescription = styled('div')`
    ${sv.h4};
    font-size: 16px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    height: 40px;
    justify-content: flex-end;
`;

const ExImage = styled('img')`
    display: flex;
    width: 100%;
    max-width: 480px;
`;

const ExTitle = styled('p')`
    margin-top: 5px;
`;

const CenteredContent = styled(`div`)`
    display: flex;
    padding-top: 80px;
    justify-content: center;
`;

const Prompt = styled('div')`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const PromptInfo = styled(Invite)`
    text-align: center;
    margin-bottom: 0;
    margin-top: 10px;
`;

// COMPONENT ##########################################################

class GetLandingPage extends Component {

    state = {
      sourceTitle: ""
    };

    updateSource = (source) => {
        this.setState({sourceTitle: source.title});
    }
    
    onClickGetStarted = () => {
        // redirect to signup
        this.props.history.push("/signup");
    }

    render() {
        const t = i18next.t;
        const { user } = this.props;

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>
                    <Header pageTitle={t("Examples")} />

                    <ContentWrapper>
                    <Content>
                        <Section>
                            <Block>
                                <Title>Explore our Gistified videos</Title>
                                <Invite>People have Gistified Business Meetings, Class Lectures, Podcasts, Online Conferences, etc.</Invite>
                                {!user &&
                                    <PitchButton onClick={this.onClickGetStarted}>Get Started</PitchButton>
                                }
                                {user &&
                                    <PitchButton onClick={() => this.props.history.push("/order")}>Create a Gist Now</PitchButton>
                                }
                            </Block>
                            <Block>
                                <Video width="100%" height="360px">
                                    <IdentifierPlayer
                                        identifier={sourceConstants.SOURCE_DEFAULT.DEBATE_20_10_07}
                                        updateSource={this.updateSource}
                                    />
                                </Video>
                                <p>{this.state.sourceTitle}</p>
                            </Block>
                        </Section>

                        <Additional>
                            <Heading>Other Gistified Videos</Heading>
                            <Section>
                                <Example onClick={() => this.props.history.push("/play/2f20308f-98c0-4347-89af-c2ec365e5dd6")}>
                                    <ExDescription>Gist finds what's important even in the chaos</ExDescription>
                                    <ExImage src="https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/2f20308f-98c0-4347-89af-c2ec365e5dd6/2f20308f-98c0-4347-89af-c2ec365e5dd6_mini.jpeg"/>
                                    <ExTitle>Presidential Debate: Trump vs. Biden - September 29, 2020</ExTitle>
                                </Example>
                                <Example onClick={() => this.props.history.push("/play/legal-use-case")}>
                                    <ExDescription>Gistify your Zoom meetings</ExDescription>
                                    <ExImage src="https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/940e2070-91f2-459d-aeb4-86c0d89fcdab/940e2070-91f2-459d-aeb4-86c0d89fcdab_mini.jpeg" />
                                    <ExTitle>A Legal Use Case - Recorded via Zoom</ExTitle>
                                </Example>
                                <Example onClick={() => this.props.history.push("/play/764102bd-2e05-4701-bed7-194204f62ec8")}>
                                    <ExDescription>Gist from the past - You can Gistify almost anything!</ExDescription>
                                    <ExImage src="https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/764102bd-2e05-4701-bed7-194204f62ec8/764102bd-2e05-4701-bed7-194204f62ec8_mini.jpeg" />
                                    <ExTitle>Presidential Debate: Bush vs. Dukakis, 1988</ExTitle>
                                </Example>
                                <Example onClick={() => this.props.history.push("/play/893db63f-23cb-4d45-9357-089351f1754d")}>
                                    <ExDescription>Review past student lectures for finals week</ExDescription>
                                    <ExImage src="https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/893db63f-23cb-4d45-9357-089351f1754d/893db63f-23cb-4d45-9357-089351f1754d_mini2.jpeg"/>
                                    <ExTitle>Business Fights Poverty - Oxford 2019 - Andrew Hunt</ExTitle>
                                </Example>
                                <Example onClick={() => this.props.history.push("/play/938e47ea-b70a-443e-961b-3953de7c092e")}>
                                    <ExDescription>You can even Gistify a podcast</ExDescription>
                                    <ExImage src="https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/938e47ea-b70a-443e-961b-3953de7c092e/938e47ea-b70a-443e-961b-3953de7c092e_mini2.jpeg"/>
                                    <ExTitle>Gods and Robots: Myths, Machines, and Ancient Dreams of Technology</ExTitle>
                                </Example>
                                <Example onClick={() => this.props.history.push("/play/4e458ae9-d3bb-40a0-b165-1ef6fb291521")}>
                                    <ExDescription>Ever tried to find something specific in a podcast?</ExDescription>
                                    <ExImage src="https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/4e458ae9-d3bb-40a0-b165-1ef6fb291521/4e458ae9-d3bb-40a0-b165-1ef6fb291521_mini2.jpeg" />
                                    <ExTitle>The Fall of the Aztecs Podcast</ExTitle>
                                </Example>
                            </Section>
                        </Additional>
                    </Content>
                    </ContentWrapper>
                    
                    <CenteredContent>
                        <Prompt>
                            <Title>What would you Gistify?</Title>
                            {!user &&
                            <>
                                <PromptInfo>30 day free trial, no credit card needed.</PromptInfo>
                                <PitchButton onClick={this.onClickGetStarted}>Get Started</PitchButton>
                            </>
                            }
                            {user &&
                            <PitchButton onClick={() => this.props.history.push("/order")}>Create a Gist Now</PitchButton>
                            }
                        </Prompt>
                    </CenteredContent>
                    
                    <Footer/>

                </Container>
            </StyledMedia>
        )
    }

}

function mapStateToProps(state) {
    const { authentication } = state;
    const { user } = authentication;
    return {
        user,
    };
}

const connectedLanding = withRouter(connect(mapStateToProps)(GetLandingPage));
export {connectedLanding as GetLandingPage};
